import { ContactPlace, MapStation } from "../../core/models";
import { LanguageService } from "../../core/services";
import { Connection } from "./models/connection";

export class MapHtml {
  static getContactPlaceIcon(): string {
    return '<svg class="placeIco" xmlns="http://www.w3.org/2000/svg" viewBox="1 1 22 22"><path d="M12,3L2,12H5V20H19V12H22L12,3M12,8.75A2.25,2.25 0 0,1 14.25,11A2.25,2.25 0 0,1 12,13.25A2.25,2.25 0 0,1 9.75,11A2.25,2.25 0 0,1 12,8.75M12,15C13.5,15 16.5,15.75 16.5,17.25V18H7.5V17.25C7.5,15.75 10.5,15 12,15Z" /></svg>'
  }

  static getContactPopup(place: ContactPlace): string {
      return `<div class="popup"><span>Kontaktní místo</span></br><span class="fw-bolder">${place.name}</span></br>`
      // + '<a href="https://iredo.info/kontaktni-mista/" target="_blank">Více informací</a></div>'
  }

  static getStopPopup(stop: MapStation, langService: LanguageService): string {
    const zones = langService.translate('zóny');
    const stopTypeImg = stop.sourceType == 'S' ? '/img/bus.svg' : '/img/train.svg';
    return `<div class="popup stop"><span class="fw-bolder">${stop.name}</span></br>` +
      `<div><img width="24px" height="24px" src="${stopTypeImg}"/>` +
      (stop.zone !== undefined ? `<span class="font-thin">${zones}: ${stop.zone}</span></div></div>` : '')
  }

  static getStopIcon(): string {
    // rhombus-medium-outline                                                                                          
    return '<svg class="stopIco" xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29"><circle cx="15" cy="15" r="4.5" fill="#FFFFFF" stroke="{mapIconColor}" stroke-width="3"/></svg>'
  }

  static getConnPopup(conn: Connection): string {
    let delayClass = "delay";
    if (conn.delay) {
      if (conn.delay < 5)
        delayClass += " small"
      else if (conn.delay >= 5 && conn.delay < 20)
        delayClass += " medium"
    }

    return `<div class="popup conn">
              <div>
                <span class="fw-bolder">${conn.prefferedName()}</span>
                ${(conn.delay ? `<span class="${delayClass}">+${conn.delay} MIN</span>` : '')}
              </div>
              <div>
                ${conn.dep}
                <span class="arr">${conn.depTime}</span>
              </div>
              <div>
                ${conn.dest}
                <span class="dep">${conn.destTime}</span>
              </div>
              <div class="state">Stav k ${conn.time}</div>
            </div>`
  }

  static getConnMarkerIcon(conn: Connection) {
    let ico = `<ellipse style="fill: rgb(255, 255, 255);" cx="250" cy="300" rx="190" ry="190"/>
  <ellipse cx="250" cy="300" rx="150" ry="150" fill="{mapIconColor}"/>
  <path d="M 252 60 L 306 133 L 198 133 L 252 60 Z" style="stroke: rgb(0, 0, 0);" transform="rotate(${conn.angle} 250 300)"/>`;
    if (!conn.angle || conn.sourceType == 'K') { // vlaky nemaji směr, proto kroužek bez šipky circle-outline.svg / alpha-v-circle-outline
      //ico = '<path d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" fill="{mapIconColor}"/>';
      ico = '<ellipse style="fill: rgb(255, 255, 255);" cx="250" cy="300" rx="175" ry="175"/><ellipse style = "stroke: rgb(0, 0, 0)" cx = "250" cy = "300" rx = "140" ry = "140" fill = "{mapIconColor}" />'
    }

    return `<svg class="trIco" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 540">${ico}</svg>`;
  }

  static getConnMarker(conn: Connection, trColor: string, extraDetailed: boolean): string {
    const name = extraDetailed ? conn.detailedName() : conn.prefferedName();
    let trHtml = `<div class="trHtml${extraDetailed ? "" : " fw-bolder"}" style="background-color:${trColor}"><nobr>${name}</nobr></br>`;
    if (extraDetailed)
      return trHtml + `<nobr><span>${conn.dep}</span></nobr></br><nobr><span>${conn.dest}</span></nobr></div>`;
    else
      return trHtml;
  }
}
